





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { minLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Toast from '../display/toast.vue';
import { WaterMetersApi, WaterTanksApi, WaterMonitorsApi } from '@/api';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: { SaveCancelButtons },
	validations: {
		addNewEntityModal: {
			name: {
				required,
				minLength: minLength(1),
			},
		},
	},
	mixins: [validationMixin],
})
export default class WaterMeterForm extends Vue {
	@Prop(Number)
	private readonly productId!: number;
	@Prop(String)
	private readonly entityName!: string;
	@Prop(Number)
	private readonly entityCount!: number;
	private waterMetersApi: WaterMetersApi = new WaterMetersApi();
	private waterTanksApi: WaterTanksApi = new WaterTanksApi();
	private waterMonitorsApi: WaterMonitorsApi = new WaterMonitorsApi();
	public loading = false;
	public addNewEntityModal = {
		name: null,
		billingTier: null,
	};

	public created() {
		this.addNewEntityModal.name = `${this.entityName} ${this.entityCount + 1}`;
		this.$v.addNewEntityModal.$touch();
	}

	public async addNewEntity(e: any) {
		e?.preventDefault();
		this.loading = true;
		try {
			const data = {
				data: {
					productId: this.$route.params.productId,
					type: this.getTableName(this.entityName),
					name: this.addNewEntityModal.name,
					billingTier: this.addNewEntityModal.billingTier,
				},
			};
			switch (this.entityName) {
				case 'Water Supply':
					await this.waterMetersApi.addWaterMeter(data);
					break;
				case 'Water Storage':
					await this.waterTanksApi.addWaterTank(data);
					break;
				case 'Water Usage':
					await this.waterMonitorsApi.addWaterMonitor(data);
					break;
				case 'Tank':
					return 'tanks';
			}
			new Toast().makeToast(`${this.entityName} Added`, 'Success', 'success');
		} catch (e) {
			let error;
			if (e.response && e.response.data) {
				error = e.response.data.message;
			} else if (e.request) {
				error = 'Network Error';
			} else {
				error = 'Unknown Error';
			}
			new Toast().makeToast(
				`${this.entityName} not Added: ${error}`,
				`Error Adding ${this.entityName}`,
				'danger',
				true,
			);
			this.submitStatus = 'ERROR';
			return;
		}
		setTimeout(() => {
			this.loading = false;
			this.$emit('loadProduct', 0);
			this.$emit('closeModal');
		}, 1000);
	}

	public getTableName(entityName) {
		switch (entityName) {
			case 'Water Supply':
				return 'water_meters';
			case 'Water Storage':
				return 'water_tanks';
			case 'Water Usage':
				return 'water_monitors';
			case 'Tank':
				return 'tanks';
		}
	}

	public isValid(field: any) {
		return field && field.$dirty ? !field.$invalid : null;
	}
}
